import { CodeIcon } from '@radix-ui/react-icons';
import { VariantProps } from 'class-variance-authority';
import { HTMLAttributes, type JSX } from 'react';

import { cn } from '../../utils/cn';
import { DocumentFile } from '../document-file';
import { Image } from '../image';
import { LottieFile } from '../lottie-file';
import { Video } from '../video';
import { thumbnailVariants } from './thumbnail-variants';

interface ThumbnailProps
  extends
    Pick<HTMLAttributes<HTMLDivElement>, 'className'>,
    VariantProps<typeof thumbnailVariants> {
  controls?: boolean;
  icon?: JSX.Element;
  src?: any;
  type?: 'image' | 'video' | 'document' | 'template';
}

function Thumbnail({
  className,
  controls,
  icon,
  size,
  src,
  type = 'document',
  variant,
  ...props
}: ThumbnailProps) {
  if (type === 'image') {
    return (
      <Image
        alt={src}
        className={cn(thumbnailVariants({ variant, size, className }))}
        src={src}
        {...props}
      />
    );
  }

  if (type === 'video') {
    return (
      <Video
        controls={controls}
        className={cn(thumbnailVariants({ variant, size, className }))}
        src={src}
        {...props}
      />
    );
  }

  if (type === 'template') {
    return (
      <DocumentFile
        icon={icon ?? <CodeIcon className="size-4" />}
        className={cn(thumbnailVariants({ variant, size, className }))}
        {...props}
      />
    );
  }

  return (
    <LottieFile
      animationData={src}
      className={cn(thumbnailVariants({ variant, size, className }))}
      fallback={
        <DocumentFile
          icon={icon}
          className={cn(thumbnailVariants({ variant, size, className }))}
          {...props}
        />
      }
      {...props}
    />
  );
}

export { Thumbnail };
